import { render } from "./AdminSysNotesTab.vue?vue&type=template&id=754917a9&ts=true"
import script from "./AdminSysNotesTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysNotesTab.vue?vue&type=script&lang=ts"

import "./AdminSysNotesTab.vue?vue&type=style&index=0&id=754917a9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__